require('./vue-axios')
require('./vue-moment')
require('./pnotify')
require('./filters')
require('./vue-simple-alert')
